import { Inject, Injectable } from '@angular/core';
import { ProductInterface } from '@vendasta/marketplace-packages';
import { BehaviorSubject, Observable } from 'rxjs';
import { mapTo, startWith } from 'rxjs/operators';
import { PRODUCTS_TOKEN } from './tokens';

@Injectable()
export class ProductSelectorService {
  private readonly selectedProducts$$ = new BehaviorSubject<ProductInterface[]>([]);
  readonly selectedProducts$: Observable<ProductInterface[]> = this.selectedProducts$$;
  readonly loadingProducts$: Observable<boolean>;

  constructor(@Inject(PRODUCTS_TOKEN) readonly products$: Observable<ProductInterface[]>) {
    this.loadingProducts$ = products$.pipe(mapTo(false), startWith(true));
  }

  setProductSelection(products: ProductInterface[]): void {
    this.selectedProducts$$.next(products);
  }

  clearProductSelection(): void {
    this.setProductSelection([]);
  }
}
